import { IUseCase } from "../../interfaces/IUseCase";
import { setUSECASESOBJECT } from "../constants/useCases.types";

export const setUseCasesObject = (useCasesObject: IUseCase[]) => {
  return {
    type: setUSECASESOBJECT,
    payload: useCasesObject,
  };
};
